module.exports = __webpack_public_path__ + "static/media/BG2.8ea1207a.jpg";